module.exports = __webpack_public_path__ + "media/7.a1dac28b.mp3";